import { Component } from '@angular/core';

@Component({
  selector: 'era-panel-header',
  templateUrl: './panel-header.component.html',
  styleUrls: ['./panel-header.component.scss'],
})
export class PanelHeaderComponent {}
